import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { BaseDto } from '@models/base/baseDto.model';
import { DtoBase } from '@models/base/dtoBase.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { PlantillaEscritoDto } from '@models/plantillaEscrito/planillaEscritoDto.model';
import { PlantillaEscritoFilter } from '@models/plantillaEscrito/plantillaEscritoFilter.model copy';
import { PlantillaEscritoService } from '@services/plantillaEscrito/plantillaEscrito.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TipoEscritoService } from '@services/tipoEscrito/tipoEscrito.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ButtonFilterTableComponent } from 'src/app/component/button-filter-table/button-filter-table.component';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { isFalsy } from 'utility-types';
import { PlantillaEscritoComponent } from '../plantilla-escrito/plantilla-escrito.component';
import { DialogParams } from 'src/app/interfaces/dialogParam.interface.model';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-list-plantilla-escrito',
  standalone: true,
  imports: [CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatDialogModule,
    MatSelectModule,
    MatCardModule,
    MatMenuModule,
    MatSnackBarModule,
    MatDividerModule,
    ButtonFilterTableComponent,
    ButtonNewComponent,
    NgxSpinnerModule,
    SinDatosParaMostrarComponent,
    MatSlideToggleModule],
  templateUrl: './list-plantilla-escrito.component.html',
  styleUrl: './list-plantilla-escrito.component.css',
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListPlantillaEscritoComponent {


  data = false
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<PlantillaEscritoDto>();
  formFilter: any;
  formBuilder: FormBuilder = new FormBuilder;
  tiposPlantilla!: DtoBase;
  plantillaForm: FormGroup;
  tiposEscrito!: BaseDto[];
  checkedFiltroAvanzado: boolean = false
  AccionesDialog = AccionesDialog;
  hasData!: boolean;

  constructor(
    private fb: FormBuilder,
    private plantillaEscritoService: PlantillaEscritoService,
    private tipoEscritoService: TipoEscritoService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private dialog: MatDialog
  ) {

    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ["titulo", "descripcion", "accion"] :
        ["titulo", "descripcion", "tipoEscrito", "fechaCreacion", "fechaModificacion", "accion"];
    });

    this.plantillaForm = this.fb.group({
      Titulo: [''],
      Descripcion: [''],
      IdTipoEscrito: [null],
      IdUsuario: [1]
    });
  }

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnInit() {
    this.getAllTipoEscrito();
  }

  filtrosAvanzados(event: any) { }


  filtrar() {

    let IdTipoEscrito = isFalsy(this.plantillaForm.controls['Titulo'].value) ? null : this.plantillaForm.controls['Titulo'].value;

    let Descripcion = isFalsy(this.plantillaForm.controls['Descripcion'].value) ? null : this.plantillaForm.controls['Descripcion'].value;

    let Titulo = isFalsy(this.plantillaForm.controls['IdTipoEscrito'].value) ? null : this.plantillaForm.controls['IdTipoEscrito'].value;

    let plantillaEscritoFilter = new PlantillaEscritoFilter();
    plantillaEscritoFilter.titulo = Titulo
    plantillaEscritoFilter.descripcion = Descripcion
    plantillaEscritoFilter.idsTipoEscrito = IdTipoEscrito
    plantillaEscritoFilter.id = null

    this.getAllByFilter(plantillaEscritoFilter)

    // if (!isFalsy(this.form))
    //   this.getAllByIdLocalidad(this.localidadDto.id)
    // else
    //   this.getAll();
  }


  getAll() {
    this.spinner.show('spListado')
    this.plantillaEscritoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spListado')
          this.dataSource.data = data
          this.hasData  = this.dataSource.data.length >= 1 ?  true : false
        },
        error => {
          this.spinner.hide('spListado')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllByFilter(plantillaEscritoFilter: PlantillaEscritoFilter) {
    this.spinner.show('spListado')
    this.plantillaEscritoService.getAllByFilter(plantillaEscritoFilter)
      .subscribe(
        data => {
          this.spinner.hide('spListado')
          this.dataSource.data = data
          this.hasData  = this.dataSource.data.length >= 1 ?  true : false
        },
        error => {
          this.spinner.hide('spListado')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllTipoEscrito() {
    this.spinner.show('spBusquedaTiposEscrito')
    this.tipoEscritoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spBusquedaTiposEscrito')
          this.tiposEscrito = data
        },
        error => {
          this.spinner.hide('spBusquedaTiposEscrito')
          this.snackBar.showError(error, "Error");
        })
  }

  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;

    const data = {
      item: { ...entidad },
      accion
    };

    const dialogRef = this.dialog.open(PlantillaEscritoComponent, {
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          // Lógica post agregar
          break;
        case AccionesDialog.Modificar:
          // Lógica post editar
          break;
        case AccionesDialog.Eliminar:
          // Lógica post eliminar
          break;
      }
    });
  }


  trackByItems(index: number, item: any): any { return item; }

}
